<template>
  <div
    v-if="helperText || helperLink"
    :class="[
      'own-input-helper-row',
      row && 'own-input-helper-row--row',
      'align-center flex-row',
      `justify-${rowJustification}`,
    ]"
  >
    <p
      v-if="helperText"
      :id="accessibilityId ? `${accessibilityId}-message` : undefined"
      class="own-input-helper-row__helper-text text-paragraph-small"
      :class="[error ? 'status-danger' : 'text-color-secondary']"
      v-text="helperText"
    ></p>
    <template v-if="helperLink && isHelperLinkInternal">
      <router-link
        class="misc-brand own-input-helper-row__helper-link text-paragraph-small"
        :to="helperLink"
        v-text="useHelperLinkAsText ? helperLink : helperLinkText"
      />
    </template>
    <template v-else-if="helperLink">
      <a
        class="misc-brand own-input-helper-row__helper-link text-paragraph-small"
        @click.prevent="openHelperLinkInNewTab"
        v-text="useHelperLinkAsText ? helperLink : helperLinkText"
      ></a>
    </template>
  </div>
</template>
<script>
export default {
  name: 'OwnInputHelperRow',
  props: {
    /**
     * Accessibility ID
     */
    accessibilityId: { type: String, default: undefined },

    /**
     * Has Error
     */
    error: { type: Boolean, default: false },

    /**
     * Link to define even more context
     */
    helperLink: { type: [String, Object], default: undefined },

    /**
     * Label to show for helper link
     */
    helperLinkText: { type: String, default: undefined },

    /**
     * Helper text to show
     */
    helperText: { type: String, default: undefined },

    /**
     * Is rendered within a row layout
     */
    row: { type: Boolean, default: false },
  },
  computed: {
    isHelperLinkInternal() {
      const { helperLink } = this

      if (typeof helperLink === 'object') {
        return true
      }

      return false
    },
    rowJustification() {
      const { row, helperText } = this

      if (row) {
        return 'start'
      } else if (!helperText) {
        return 'end'
      } else {
        return 'between'
      }
    },
    useHelperLinkAsText() {
      const { helperLink, helperLinkText } = this

      if (helperLink && !helperLinkText) {
        return true
      }

      return false
    },
  },
  methods: {
    openHelperLinkInNewTab() {
      const { helperLink } = this

      window.open(helperLink, '_blank')
    },
  },
}
</script>
<style lang="scss">
.own-input-helper-row {
  &--row {
    margin-top: 0;
  }

  &__helper-text {
    margin-right: 8px;
  }

  &__helper-link {
    text-decoration: none;
  }
}
</style>
